/*
 * Which URLs are used depends on the command — no more commenting lines in/out:
 *
 *   npm start            → LOCAL URLs  (development server)
 *   npm run build:test   → LOCAL URLs  (test build)
 *   npm run build:prod   → PROD URLs   (production build)
 *   npm run build        → PROD URLs   (same as build:prod)
 *
 * (package.json sets REACT_APP_ENV=test / prod for the two builds.)
 * Any single value can still be overridden with a REACT_APP_* variable in .env
 * (e.g. REACT_APP_API_URL=https://npgwfm.cyient.com), then restart / rebuild.
 */
const ENVIRONMENTS = {
  local: {
    webap_url: "http://localhost:4051",
    react_loging: "local", // username/password login
    redirect_url: "http://localhost:3000/viewtasks",
  },
  prod: {
    webap_url: "/test",
    react_loging: "azure", // Azure AD (MSAL) login
    redirect_url: "https://npgwfm.cyient.com/viewtasks",
  },
};
ENVIRONMENTS.test = ENVIRONMENTS.local; // test build = local URLs

const APP_ENV = process.env.REACT_APP_ENV || (process.env.NODE_ENV === "production" ? "prod" : "local");
const ENV = ENVIRONMENTS[APP_ENV] || ENVIRONMENTS.prod;
const webap_url = process.env.REACT_APP_API_URL || ENV.webap_url;
const react_loging = process.env.REACT_APP_LOGIN_MODE || ENV.react_loging;
const redirect_url = process.env.REACT_APP_REDIRECT_URL || ENV.redirect_url;



const config = {
  react_loging: {
    react_Login_With_url: `${react_loging}`
  },
  Redirect: {
    redirect_url: `${redirect_url}`,
  },
  Login: {
    LoginURL: `${webap_url}/api/security/login`,
  },
  DatabaceConnection: {
    URL: `${webap_url}/dbconnection_check`,
  },
  EmailRequest: {
    url: `${webap_url}/send-email_azure`
  }, SpareEmailRequest: {
    url: `${webap_url}/send-email-spare`
  },
  EmailRequestEvents: {
    url: `${webap_url}/email-events`
  },
  DownloadFile: {
    url: `${webap_url}/api/data/export-csv`
  },
  GetExistingvalue: {
    url: `${webap_url}/api/data/Existingvalue`,
  },
  ProcessQuery: {
    url: `${webap_url}/api/data/ProcessQuery`,
  },
  UpLoadFile: {
    url: `${webap_url}/api/uploadjobs/UploadFile`,
  },
  UpdateJobs: {
    url: `${webap_url}/api/data/UpdateData`,
  },
  DeleteJobs: {
    url: `${webap_url}/api/data/DeleteData`,
  },
  UpdateTimesheet: {
    url: `${webap_url}/api/data/UpdateTimesheet`,
  },
  InsertData: {
    url: `${webap_url}/api/data/InsertData`,
  },
  ProcessQueryWitVals: {
    url: `${webap_url}/api/data/ProcessQueryWithVals`,
  },
  ProcessQueryWitJSON: {
    url: `${webap_url}/api/data/ProcessQueryWithJSON`,
  },

  UpdateDatawithfunction: {
    url: `${webap_url}/api/data/UpdateDatawithfunction`,
  },
  TaskProcessQueryWithVals: {
    url: `${webap_url}/api/data/TaskProcessQueryWithVals`,
  },

  UploadJobsFromJSON: {
    url: `${webap_url}/api/uploadjobs/UploadJobsFromJSON`,
  },
  ProcessDataTableQuery: {
    url: `${webap_url}/api/data/ProcessDataTableQuery`,
  },
  ProcessDataTable: {
    url: `${webap_url}/api/data/ProcessDataTable`,
  },
  ProcessDataTableQueryStreamData: {
    url: `${webap_url}/api/data/ProcessDataTableQueryStreamData`,
  },
  ProcessQueryCursor: {
    url: `${webap_url}/api/data/ProcessQueryCursor`,
  },
  ProductivityPercMax: 1000,
  DataEntryColumnOrder: `Asbuilt (Y/N),Lat,Long,ERP ID,Location/Parent Feature,Location/Parent Feature ID,Feature,Feature ID (GESW),Input Status,Tool Output Result,Final Status`,

  UploadLocalfiles: {
    url: `${webap_url}/uploads/`,
  },
  UpdateTabels: {
    url: `${webap_url}/api/data/updatetables`,
  },
  TableColumns: {
    Viewdocuments: `document_id,document_name,document_type,document_type,activity_ref,construction_date,received_date,ehv_cable,hv_cable,lv_cable,aux,no_of_services,volume_services,plant,supports,document_path,status,job_id,job_title,created_date,task_id,job_status,original_document_name,username,username,comments,created_date1,received_date1,construction_date1,contractor_name,contractor_id,activitystatusid`,
  },
  DisplayColumns: {
    Viewdocuments: `document_id,document_name,document_type,document_type,activity_ref,construction_date,received_date`,
  },
};
export default config;